import { render, staticRenderFns } from "./RegisterFormMoova.vue?vue&type=template&id=053565f6"
import script from "./RegisterFormMoova.vue?vue&type=script&lang=js"
export * from "./RegisterFormMoova.vue?vue&type=script&lang=js"
import style0 from "./RegisterFormMoova.vue?vue&type=style&index=0&id=053565f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports